import defaultPosition from "@/helpers/wc/positionSettings";

export const eventsCalendarSettings = {
  title: 'EventsCalendar',
  name: 'eventsCalendarBase',
  styles: defaultPosition,

  properties: {
    calendarUrl: '',
    pageSize: 5,
    showPageholders: true,
    hideCategories: 'procon',
    css: {
      events: {
        fontFamily: "Arial",
        fontSize: 14,
        color: 'black',
        backgroundColor: 'white',
        padding: '10px',
        paddingBottom: '15px',
        borderColor: 'rgb(57, 61, 121)',
        borderWidth: '2px'
      },
      details: {
        paddingTop: '0'
      },
      date: {
        fontFamily: "Arial",
        fontSize: '16px',
        padding: '5px',
        color: 'black',
        backgroundColor: 'white'
      },
      summary: {
        fontFamily: "Arial",
        fontSize: '20px',
        color: 'rgb(223 110 30)',
        padding: '5px'
      },
      navigation: {
        backgroundColor: 'white',
        padding: '5px',
        paddingTop: '10px',
        borderRadius: 0
      },
      button: {
        fontSize: '20px',
        color: 'black',
        backgroundColor: 'white',
        width: '35px',
        padding: '5px',
        borderColor: 'grey',
        borderWidth: '2px',
        borderRadius: '20px'
      },
      prevButton: {
        top: 0,
        left: '20px'
      },
      nextButton: {
        top: 0,
        right: '20px'
      },
      placeholder: {
        fontSize: 15,
        color: '#aeb7e2',
        padding: '0'
      }
    }
  },
  cssLegend: {
    events: {
      name: 'events',
      fontFamily: {
        type: 'fontFamily',
        name: 'fontFamily'
      },
      fontSize: {
        type: 'int',
        name: 'fontSize',
        handler: val => val + 'px'
      },
      color: {
        type: 'color',
        name: 'color'
      },
      backgroundColor: {
        type: 'color',
        name: 'background'
      },
      padding: {
        type: 'int',
        name: 'padding',
        handler: val => val + 'px'
      },
      paddingBottom: {
        type: 'int',
        name: 'paddingBottom',
        handler: val => val + 'px'
      },
      borderColor: {
        type: 'color',
        name: 'border'
      },
      borderWidth: {
        type: 'int',
        name: 'borderWidth',
        handler: val => val + 'px'
      }
    },
    details: {
      name: 'eventDetails',
      paddingTop: {
        type: 'int',
        name: 'padding',
        handler: val => val + 'px'
      }
    },
    date: {
      name: 'dateCaption',
      fontFamily: {
        type: 'fontFamily',
        name: 'fontFamily'
      },
      fontSize: {
        type: 'int',
        name: 'fontSize',
        handler: val => val + 'px'
      },
      padding: {
        type: 'int',
        name: 'padding',
        handler: val => val + 'px'
      },
      color: {
        type: 'color',
        name: 'color'
      },
      backgroundColor: {
        type: 'color',
        name: 'background'
      }
    },
    summary: {
      name: 'header',
      fontFamily: {
        type: 'fontFamily',
        name: 'fontFamily'
      },
      fontSize: {
        type: 'int',
        name: 'fontSize',
        handler: val => val + 'px'
      },
      color: {
        type: 'color',
        name: 'color'
      },
      padding: {
        type: 'int',
        name: 'padding',
        handler: val => val + 'px'
      }
    },
    navigation: {
      name: 'pageNavigation',
      backgroundColor: {
        type: 'color',
        name: 'background'
      },
      padding: {
        type: 'int',
        name: 'padding',
        handler: val => val + 'px'
      },
      paddingTop: {
        type: 'int',
        name: 'paddingTop',
        handler: val => val + 'px'
      },
      borderRadius: {
        type: 'int',
        name: 'borderRadius',
        handler: val => val + 'px'
      }
    },
    button: {
      name: 'pageButton',
      fontSize: {
        type: 'int',
        name: 'fontSize',
        handler: val => val + 'px'
      },
      color: {
        type: 'color',
        name: 'color'
      },
      backgroundColor: {
        type: 'color',
        name: 'background'
      },
      width: {
        type: 'int',
        name: 'width',
        handler: val => val + 'px'
      },
      padding: {
        type: 'int',
        name: 'padding',
        handler: val => val + 'px'
      },
      borderColor: {
        type: 'color',
        name: 'border'
      },
      borderWidth: {
        type: 'int',
        name: 'borderWidth',
        handler: val => val + 'px'
      },
      borderRadius: {
        type: 'int',
        name: 'borderRadius',
        handler: val => val + 'px'
      }
    },
    prevButton: {
      name: 'prevButton',
      top: {
        type: 'int',
        name: 'top',
        handler: val => val + 'px'
      },
      left: {
        type: 'int',
        name: 'left',
        handler: val => val + 'px'
      }
    },
    nextButton: {
      name: 'nextButton',
      top: {
        type: 'int',
        name: 'top',
        handler: val => val + 'px'
      },
      right: {
        type: 'int',
        name: 'right',
        handler: val => val + 'px'
      }
    },
    placeholder: {
      name: 'pagePlaceholder',
      fontSize: {
        type: 'int',
        name: 'fontSize',
        handler: val => val + 'px'
      },
      color: {
        type: 'color',
        name: 'color'
      },
      padding: {
        type: 'int',
        name: 'padding',
        handler: val => val + 'px'
      }
    }
  }
};
